import { Pipe } from "@angular/core";

@Pipe({ name: "isnull" })
export class IsNullPipe {
    transform(valor: any, substituirPor: string = "-"): any {
        if (valor) {
            return valor;
        }
        return substituirPor;
    }
}
